import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import '../css/screens/ViewerPage.scss';
import { ArrowRight } from '../ui/Vectors';
import Link from '../css/ui/Link';
import ContentBuilder from '../core/ContentBuilder';

export default class ViewerPage extends Page {


	renderReleases()
	{
		if(!this.props.content.releases) return null;
		let content = this.props.content.releases;
		return (
			<Grid cols={2} skip={1} breakpoints={{small: {cols: 4, skip: 0}}} className='releases'>
				<div className='title'>{content.title}</div>
				<div className='blocks'>
					{content.items.map((item, i) => {
						return (<NewsBlock key={i} data={item}></NewsBlock>)
					})}
				</div>
			</Grid>
		);
	}

	renderMilestones()
	{
		if(!this.props.content.milestones) return null;
		let content = this.props.content.milestones;
		return (
			<Grid cols={2} skip={1} breakpoints={{small: {cols: 4, skip: 0}}} className='milestones'>
				<div className='title'>{content.title}</div>
				<div className='blocks'>
					{content.items.map((item, i) => {
						return (<NewsBlock key={i} data={item}></NewsBlock>)
					})}
				</div>
			</Grid>
		);
	}

	renderHowto()
	{
		if(!this.props.content.howto) return null;
		let content = this.props.content.howto;
		return (
			<div className='howto'>
				<div className='title'>{content.title}</div>
				<div className='content'>
					<Grid cols={3} breakpoints={{small: {cols: 4, skip: 0}}}>
						{ContentBuilder.build(content.content)}
					</Grid>
				</div>
			</div>
		);
	}

	renderTech()
	{
		if(!this.props.content.tech) return null;
		let content = this.props.content.tech;
		return (
			<div className='tech'>
				<div className='title'>{content.title}</div>
				<div className='content padding'>
					<Grid cols={2} breakpoints={{small: {cols: 4, skip: 0}}}>
						{ContentBuilder.build(content.content)}
						<Button grid={{default: {cols: 4}}} {...content.button} border={true}>
							<span className="flex flex-baseline">
								<span className="label">{content.button.label}</span>
								<span className="description">{content.button.description}</span>
							</span>
							<span className="label-right flex-middle">
								<span className="actionLabel show-medium">{content.button.actionLabel}</span>
								<ArrowRight className='arrow'></ArrowRight>
							</span>
						</Button>
					</Grid>
				</div>
			</div>
		);
	}

	render() {
		return this.wrap(
			<React.Fragment>
				<div className="header padding">
					<div className='title'>{this.props.content.title}</div>
					<div className='text'>{this.props.content.text}</div>
				</div>
				<div className='main'>
					<Grid cols={3} breakpoints={{small: {cols: 4, skip: 0}}}>
						<img alt={this.props.content.image.src} src={this.props.content.image.src} width={this.props.content.image.width} height={this.props.content.image.height} />
						<div className='text padding'>{this.props.content.description}</div>
						<Button grid={{default: {cols: 4}}} url={this.props.content.button.url} border={true}>
							<span className="flex flex-baseline">
								<span className="label">{this.props.content.button.label}</span>
								<span className="description">{this.props.content.button.description}</span>
							</span>
							<span className="label-right flex-middle">
								<span className="actionLabel show-medium">{this.props.content.button.actionLabel}</span>
								<ArrowRight className='arrow'></ArrowRight>
							</span>
						</Button>
						<div className="padding text-right note">{this.props.content.note}</div>
					</Grid>
				</div>
				{this.renderReleases()}
				{this.renderMilestones()}
				{this.renderHowto()}
				{this.renderTech()}
			</React.Fragment>
		);
	}
}


function NewsBlock(props:{data})
{
	return (
		<div className='news'>
			<div className='head'>
				<div className='news-title'>{props.data.title}</div>
				<div className='description'>{props.data.description}</div>
			</div>
			<hr></hr>
			<ul>
				{props.data.items.map((item, i) => {
					if(item['link'])
					{
						return (<li key={i}><Link to={item['link']}>{item['text']}</Link></li>);
					}
					return (<li key={i}>{item['text']}</li>);
				})}
			</ul>
		</div>);
}
